import script from "./NeuCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NeuCard.vue?vue&type=script&setup=true&lang=js"

import "./NeuCard.vue?vue&type=style&index=0&id=a8ecf6c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8ecf6c6"]])

export default __exports__